import {Component, HostListener, inject, OnInit} from '@angular/core';
import { NavService } from '../../service/nav.service';
import { trigger, transition, useAnimation } from '@angular/animations';
import { bounce, zoomOut, zoomIn, fadeIn, bounceIn } from 'ng-animate';
import {AuthService} from '../../service/auth.service';
import {CommonDataService} from '../../service/common-data.service';
import {ConfigurationService} from '../../service/configuration.service';
import {EnvironmentService} from '../../../environment.service';
import {CreatorService} from '../../service/creator.service';

@Component({
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
  styleUrls: ['./content-layout.component.scss'],
  animations: [
    trigger('animateRoute', [transition('* => *', useAnimation(fadeIn, {
      // Set the duration to 5seconds and delay to 2 seconds
      //params: { timing: 3}
    }))])
  ]
})
export class ContentLayoutComponent implements OnInit {
  public allowDashboard: any;
  public right_side_bar: boolean;
  public layoutType: string = 'RTL';
  public layoutClass: boolean = false;
  public imgUrl: string;
  public profile: any;
  isHovered = false;
  public showMobView = false;
  public showMobileView = false;
  public creatorService = inject(CreatorService);
  @HostListener('window:resize', ['$event'])
  onResize(event){
    this.showMobView = this.env.deviceType();
    this.showMobileView = this.env.mobileDeviceType();
  }
  constructor(public navServices: NavService, public env: EnvironmentService,
              public auth: AuthService, public commondata: CommonDataService, public config: ConfigurationService) {
    this.imgUrl = this.config.getimgUrl();
    this.profile = this.auth.getSessionData('profile_url');
    this.showMobView = this.env.deviceType();
    this.showMobileView = this.env.mobileDeviceType();
    this.creatorService.contentView.subscribe((res: any) => {
      this.isHovered = !(res == true);
      this.auth.setSideBarOpened(this.isHovered);
    });
  }

  onSidebarHover() {
    if (this.navServices.collapseSidebar) {
      this.isHovered = true;
      this.navServices.sidebarHovered = true;
      this.auth.setSideBarOpened(true);
    }
  }

  onSidebarLeave() {
    if (this.navServices.collapseSidebar) {
      this.isHovered = false;
      this.navServices.sidebarHovered = false;
      this.auth.setSideBarOpened(false);
    }
  }

  public getRouterOutletState(outlet) {
    this.allowDashboard = this.auth.getSessionData('default_password');
    return outlet.isActivated ? outlet.activatedRoute : '';
  }

  public rightSidebar($event) {
    this.right_side_bar = $event;
  }

  public clickRtl(val) {
    if (val === 'RTL') {
      document.body.className = 'rtl';
      this.layoutClass = true;
      this.layoutType = 'LTR';
    } else {
      document.body.className = '';
      this.layoutClass = false;
      this.layoutType = 'RTL';
    }
  }

  ngOnInit() {
    // this.commondata.showLoader(true);
  }

  get loginAsStudentOrTeacher() {
    const url = window.location.href;
    return !this.showMobView && !url.includes('login/asStudent') && !url.includes('login/asTeacher');
  }

  get hideForBreadcrumb() {
    const url = window.location.href;
    return !this.showMobView && (!url.includes('student/dashboard') && !url.includes('report/report') && !url.includes('login/asTeacher') &&
        !url.includes('studentlogin/answering') && !url.includes('sat-report') && !url.includes('login/asStudent'));
  }

}
